module.exports = __webpack_public_path__ + "static/CircularStd-BlackItalic-e13b5c7b607cba29c792f13d5328ddb6.woff";